/**
 * API fetcher for Stage 075 Quantitative Strategy Matrix & MTF Confluence.
 * Governance Anchor: Stage 075 Architecture Proposal v1.3.0
 */

import { apiClient } from '../../api/client';

export interface StrategyMatrixMetric {
  strategy_id: string;
  name: string;
  tier: 'SINGLE' | 'DUAL' | 'MULTI';
  direction: 'LONG' | 'SHORT';
  entry_tags: string[];
  exit_tags: string[];
  sample_count: number;
  completed_trades: number;
  wins?: number;
  win_rate: string | null;
  profit_factor: string | null;
  net_return_pct: string | null;
  signal_exit_ratio: string | null;
  alpha_edge: string | null;
  avg_holding_bars?: string;
  description: string;
  rationale: string;
  timeframes_covered?: string[];
}

export interface StrategyMatrixEnvelope {
  symbol: string;
  timeframe: string;
  as_of_utc: string | null;
  generated_at_utc: string;
  freshness_status: 'FRESH' | 'STALE' | 'EMPTY';
  duration_ms: number | null;
  metrics: StrategyMatrixMetric[];
  payload_digest: string | null;
}

export async function fetchStrategyMatrix(
  symbol: string,
  timeframe: string,
  signal?: AbortSignal
): Promise<StrategyMatrixEnvelope> {
  return apiClient.get<StrategyMatrixEnvelope>('/api/v1/regime/strategy-matrix', {
    params: { symbol, timeframe },
    signal,
  });
}

export async function fetchCrossTimeframeMatrix(
  symbol: string,
  signal?: AbortSignal
): Promise<StrategyMatrixEnvelope> {
  return apiClient.get<StrategyMatrixEnvelope>('/api/v1/regime/strategy-matrix/cross-tf', {
    params: { symbol },
    signal,
  });
}
